import { render, staticRenderFns } from "./wechatGroup_node_form.vue?vue&type=template&id=021e6473&"
import script from "./wechatGroup_node_form.vue?vue&type=script&lang=js&"
export * from "./wechatGroup_node_form.vue?vue&type=script&lang=js&"
import style0 from "./wechatGroup_node_form.vue?vue&type=style&index=0&id=021e6473&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports